export default "__VITE_ASSET__ET0gjZ22__"